import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IContainers {
  id: string;
  status: string;
  description: string;
  barcode: string;
  companyId: number;
  returnPointId: number;
  price: number;
  manufacturer: string;
}

export class IContainersResponse {
  @Type(() => IContainers)
  result: IContainers;
}

export class IContainersListResponse extends IPagination {
  @Type(() => IContainers)
  results: IContainers[];
}

export class IContainersQueryDto extends IQueryPaginationDto {
  status?: string;
  description?: string;
  barcode?: string;
  companyId?: number;
  returnPointId?: number;
  price?: number;
  manufacturer?: string;
}

export class IContainersPostDto {
  status: string;
  description: string;
  barcode: string;
  companyId: number;
  returnPointId: number;
  price: number;
  manufacturer: string;
}

export class IContainersPatchDto {
  status: string;
  description: string;
  barcode: string;
  companyId: number;
  returnPointId: number;
  price: number;
  manufacturer: string;
}
